import { lazy } from 'react';

export const Proficiency = lazy(() => import('./Proficiency'));
export const FindYourLevel = lazy(() => import('./FindYourLevel'));
export const Level = lazy(() => import('./Level'));
export const SubLevel = lazy(() => import('./SubLevel'));
export const Summary = lazy(() => import('./Summary'));
